<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Loading
  </div>
  <div v-else class="animated fadeIn">
    <prep-process-card v-if="prep_process" :prep_process="prep_process" />
    <b-form @submit.prevent="onSubmit">
      <b-row class="mt-4">
        <b-col>
          <b-card no-body>
            <b-card-header>
              <span class="text-muted text-uppercase"
                >Prep Process Identification</span
              >
            </b-card-header>
            <div class="py-3 px-5">
              <b-form-group label="Sample Types" :label-cols="2" class="mb-2">
                <b-button
                  v-for="(sample_type, index) in sample_type_collection.models"
                  :key="index"
                  :variant="
                    form_data.sample_types.find((id) => id === sample_type.id)
                      ? 'primary'
                      : 'light'
                  "
                  @click="selectSampleType(sample_type.id)"
                  class="mr-2 mb-2"
                >
                  {{ sample_type.name }}
                </b-button>
              </b-form-group>
              <b-form-group label="Identifier" :label-cols="2">
                <b-form-input
                  type="text"
                  v-model="form_data.name"
                  placeholder="Process Name"
                />
              </b-form-group>
              <b-form-group label="Description" :label-cols="2">
                <b-form-textarea
                  v-model="form_data.description"
                  placeholder="Description"
                />
              </b-form-group>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button
            @click="submitForm"
            class="my-4 float-right py-3 px-5"
            variant="success"
          >
            <i class="fal fa-address-book" /> Save
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import PrepProcessCard from "@/components/lab/prepprocess/PrepProcessCard";
import { getCollection } from "@/shared/fetch-utils";

export default {
  name: "PrepProcessForm",
  components: {
    PrepProcessCard,
  },
  props: {
    prep_process: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      loading: true,
      form_data: {
        name: null,
        description: null,
        sample_types: [],
        prep_tasks: [],
      },
      sample_type_id: this.$route.params.sample_type_id || null,
      sample_type_collection: null,
    };
  },
  methods: {
    initFormData() {
      if (this.prep_process) {
        const { name, description, sample_types } = this.prep_process;
        this.form_data = {
          name,
          description,
          sample_types: sample_types.length
            ? sample_types.map(({ id }) => id)
            : [],
        };
      }

      this.sample_type_id &&
        (this.form_data.sample_types = [this.sample_type_id]);
    },
    async init() {
      this.sample_type_collection = await getCollection({
        collection_type: "sample_type",
        message: this.$bvToast,
      });

      this.initFormData();

      this.loading = false;
    },

    submitForm() {
      this.$emit("submit", this.form_data);
    },

    selectSampleType(sample_type_id) {
      this.form_data.sample_types.find((id) => id === sample_type_id)
        ? (this.form_data.sample_types = this.form_data.sample_types.filter(
            (id) => id !== sample_type_id
          ))
        : (this.form_data.sample_types = [
            ...this.form_data.sample_types,
            sample_type_id,
          ]);
    },
  },

  mounted() {
    this.loading = true;

    this.init();
  },
};
</script>
